import { render } from "./URIEncoderDecoder.vue?vue&type=template&id=5e5da293&scoped=true"
import script from "./URIEncoderDecoder.vue?vue&type=script&lang=js"
export * from "./URIEncoderDecoder.vue?vue&type=script&lang=js"

import "./URIEncoderDecoder.vue?vue&type=style&index=0&id=5e5da293&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5da293"]])

export default __exports__